var map = {
	"./en.json": [
		6082,
		82
	],
	"./fr.json": [
		4521,
		521
	],
	"./php_en.json": [
		5703,
		703
	],
	"./php_fr.json": [
		2644,
		644
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5852;
module.exports = webpackAsyncContext;